module.exports = __webpack_public_path__ + "static/for_whom_general_meetings-6bcb1476f04c6666eafebf0dea2a698f.jpg";